import { useGetUserInfo, useGetUserScopes } from "lib/userInfo";
import { useEffect, useState } from "react";
import { ability } from "./config/ability";
import { parseScopes } from "./parseScopes";

export const useAuthorization = () => {
  const [isAuthCheckDone, setIsAuthCheckDone] = useState(false);
  const userInfo = useGetUserInfo();
  const userScopes = useGetUserScopes();
  useEffect(() => {
    if (userInfo) {
      const parsedScopes = parseScopes(userScopes);
      ability.update([...parsedScopes]);
      setIsAuthCheckDone(true);
    }
  }, [userInfo, userScopes]);

  return { isAuthCheckDone, userScopes };
};
